import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CouponCompleteTemplate } from 'components/Templates'

const CouponComplete: FC = () => {
  return (
    <Layout headline={'クーポン'} iconPath={'/icon/white/coupon.svg'} title={'完了 | 新規クーポン作成'}>
      <CouponCompleteTemplate />
    </Layout>
  )
}

export default CouponComplete
